module.exports = __webpack_public_path__ + "static/media/applepayLight.c1b9089f.svg";